import {
  GET_DEVICETYPES_CATALOG,
  GET_DEVICETYPES_CATALOG_SUCCESS,
  GET_DEVICETYPES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getDeviceTypesCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_DEVICETYPES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_DEVICETYPES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_DEVICETYPES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
